<div class="acc-content mgbtm">
  <div class="">
  <div *ngIf="sections.registrationNumberSection">
      <form #carSelectionSingleForm="ngForm" (ngSubmit)="onCarSingleSelectionFormSubmit(carSelectionSingleForm)">
     <div class="row" >
          <div class="col-100 xscol-100 smcol-100 mdcol-100">
            <div>
              <div class="row">
                <div class="col-100 xscol-100 mbt20 mtp20">
                  <p translate class="font18">
                    lblEnrterMobileSMSSend
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-50 xscol-100 smcol-50 mdcol-50">
                  <div class="cst-input-field big input-with-icn mbt20">
                    <label translate class="label-big mbt10 dis-blk">
                      lblEnterMobileNumber<strong class="required mlt6">*</strong>
                    </label>
                    <div class="pos-relative ">
                      <ngx-intl-tel-input [selectFirstCountry]= "false" [cssClass]="{'form-control': true}" id="mobileNo" [(ngModel)]="mobileNumber" #mobileNo="ngModel" disabled name="mobileNo"
                      [selectedCountryISO]="selectedCountryISOMobile" [maxLength]="15" [phoneValidation]="false"
                      [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                      [customPlaceholder]="'lblEnterMobile' | translate" (input)="onchange($event,carSelectionSingleForm)"
                      (countryChange)="onRegNoCountryChange($event)" required
                      ></ngx-intl-tel-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-100">
            <div class="btn-grp fright xsmbt10">
              <button aria-label="Center Align" class="btn mrt20 btn-secondary" translate
                (click)="goToPrevious()" type="button">
                <em class="pos-relative font18 fa fa-angle-left mr-2"></em> lblBack
              </button>
              <button  aria-label="Center Align" translate class="btn btn-primary fleft" id="showRegPhoneNumber"
                (click)="validateMobileNumberField(carSelectionSingleForm.valid)" type="submit">
                lblNext <em class="pos-relative font18 fa fa-angle-right ml-2"></em>
              </button>
            </div>
          </div>
        </div>
        <div #otpTimer hidden></div>
      </form>
  </div>


    <div id="regOtpSection" *ngIf="sections.regOtpSection">
      <div class="mbt20">
        <p class="font18 mbt10"><strong translate>lblVerifyYourIdentity</strong></p>
        <p class="font16" translate>lblEnterCodeYouReceivedOnSMSToConfirm</p>
      </div>

      <div class="row xsmbt0">
        <div class="col-30 xscol-100 smcol-40 xsmbt15 smmbt40">
          <div class="cst-input-field">
            <label translate class="label-big" for="otp">lblEnterCode</label>
            <div class="pos-rel">
              <input type="text" id="OTPInput" name="OTPInput" class="form-control" required (keypress)="isDigit($event)" 
                [(ngModel)]="OTP" minlength="6" maxlength="6" #OTPInput="ngModel" />
            </div>
          </div>
        </div>
        <div class="col-50 xscol-100 smcol-60 search-cont xsmbt10">
          <div class="btn-grp mb xsfright">
            <button translate type="submit" aria-label="Center Align" class="btn btn-primary" id="showCarSelectionDouble" 
            (click)="verifyOtp()" [disabled]="!OTPInput.valid">
              lblConfirm
            </button>
            <button translate type="button" aria-label="Center Align" class="btn btn-secondary"
              (click)="onChangePhoneNo()">
              lblChangeThePhoneNumber
            </button>
          </div>
        </div>
        <div class="col-100 xsrel" class="col-100 xsrel mgtop">
          <div class="d-block">
            <span class="d-sm-block">
            <a href="javascript:void(0);" *ngIf="!timeout" class="font16 disabled">
              <span translate class="mrt10 xsmrt5 text-underline"  >lblResendOTP</span></a>
              <a href="javascript:void(0);" *ngIf="timeout" class="clrblue font16 togglelink" (click)="ResendOTP()">
                <span translate class="mrt10 xsmrt5 text-underline"  >lblResendOTP</span></a>
                <span #otpTimer class="clrgreen"></span>
                &nbsp;<span class="success-msg p-2" *ngIf="successMsg">
                  <em class="fa fa-check"></em>
                  <span translate>lblOTPIsSentSuccessfully</span>
                </span>
              </span>


          </div>
          <div class="d-block mt-2 pt10 mob-font11" >
            <span translate>lblOTPHasBeenSentToYourMobileNumber</span>:+{{userAuthMobilecode}}{{mobileNumber}}
          &nbsp;
          </div>
        </div>
      </div>
    </div>
    <div class="section-contact-info" *ngIf="sections.customerDetailSection">
      <div class="row">
        <div class="col-12">
          <form [formGroup]="contactFormDetails" (ngSubmit)="onSubmit()">
           
            <div class="row mbt15 xsmbt0">
              <div class="col-12 col-md-6">
                <div class="cst-input-field">
                  <label translate>lblName</label>
                  <input type="text" formControlName="Name"  class="form-control" readonly="" />
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="cst-input-field">
                  <label translate>lblMobileNo</label>
                  <ngx-intl-tel-input [selectFirstCountry]= "false" [cssClass]="{'form-control': true}" formControlName="MobileNumber" disabled
                  [selectedCountryISO]="selectedCountryISOMobileNumber" [maxLength]="11" [phoneValidation]="false"
                  [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"
                  ></ngx-intl-tel-input>
                </div>
              </div>
            </div>
            <div class="row mbt15 xsmbt0">
              <div class="col-12 col-md-6">
              <div class="cst-input-field">
                <label translate>lblZipCode</label>
                <input type="text" formControlName="PinCode" class="form-control" maxlength="10"  readonly=""/>
                <div *ngIf="ContactFormControls.PinCode.touched || ContactFormControls.PinCode.dirty">
                  <div translate *ngIf="ContactFormControls.PinCode.errors?.required" class="cst-validation-msg">
                    lblPleaseEnterTheValue</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="cst-input-field">
                <label translate>lblEmail</label>
                <input type="text" formControlName="Email" class="form-control" maxlength="50"  readonly=""/>
                <div *ngIf="ContactFormControls.Email.touched || ContactFormControls.Email.dirty">
                  <div translate *ngIf="ContactFormControls.Email.errors?.required" class="cst-validation-msg">
                    lblPleaseEnterTheValue</div>
                  <div translate *ngIf="ContactFormControls.Email.errors?.pattern" class="cst-validation-msg">
                    lblPleaseEnterTheValue
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="row mbt30 xsmbt20">

              <div class="col-12 mtp40 mbt20 xsmtp20 smmtp20 xsmbt0 mdmbt20" *ngIf="!readOnlyNomineeMobile">
                <p translate class="font18">
                  lblIfYouWantUsToContactSomeoneElse
                </p>
              </div>
              <div class="col-12 mtp40 mbt20 xsmtp20 smmtp20 xsmbt0 mdmbt20" *ngIf="readOnlyNomineeMobile">
                <p translate class="font18">
                  lblDifferentNumberEntered
                </p>
              </div>
              <div class="col-12 col-md-6">
                <div class="cst-input-field">
                  <label translate >lblName<span class="clrred" *ngIf="readOnlyNomineeMobile" >*</span></label>
                  <input type="text" formControlName="NomineeName" class="form-control" [required]="readOnlyNomineeMobile" />
                  <div *ngIf="ContactFormControls.NomineeName.touched || ContactFormControls.NomineeName.dirty">

                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="cst-input-field">
                  <label translate>lblMobileNo</label>
                  <ngx-intl-tel-input [selectFirstCountry]= "false" [cssClass]="{'form-control': true}" formControlName="NomineeMobileNumber" [disabled]="readOnlyNomineeMobile"
                  [selectedCountryISO]="selectedCountryISONomineeMob" [maxLength]="15" [phoneValidation]="false" (keyup)="onMobileNoChange()"
                  [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"
                  (countryChange)="onCountryChange($event)"
                  ></ngx-intl-tel-input>
                  <div *ngIf="ContactFormControls.NomineeMobileNumber.touched ||
                    ContactFormControls.NomineeMobileNumber.dirty">
                    <div translate *ngIf="ContactFormControls.NomineeMobileNumber.errors?.pattern" class="cst-validation-msg" translate>
                      lblEnterValidMobile
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mbt30">

            
            <div class="col-12 mr-auto" *ngIf="TCLink">
                  <div class="form-group mb-0 mt-2">
                      <label class="cstcheckbox flmid fullspace w100 bold
                      font16">
                          <input type="checkbox" name="UserPrivacyAccept" formControlName="UserPrivacyAccept"
                              id="UserPrivacyAccept" class="form-check-input" required />
                          <span></span>
                          <p class="m-0 p-0">
                            <strong class="required-field font-weight-normal"  translate>lblreadpolicy</strong>&nbsp;<u><a [href]="TCUrl" class="link" target="_blank" rel="noopener noreferrer" translate>lblprivacy</a></u>&nbsp;<strong class="required-field font-weight-normal"  translate>lblpolicy</strong>
                          </p>
                      </label> 
                  </div>
                  <div class="form-group mb-0 mt-2">
                    <label class="cstcheckbox flmid fullspace w100 bold
                    font16">
                        <input type="checkbox" name="UserConsent" formControlName="UserConsent"
                            id="UserConsent" class="form-check-input" />
                        <span></span>
                        <p class="m-0 p-0">
                       <strong class="required-field font-weight-normal"  translate>lblReceiveDigitalMarket</strong>&nbsp;<u><a [href]="TCUrl" class="link" target="_blank" rel="noopener noreferrer" translate>lblprivacy</a></u>&nbsp;<strong class="required-field font-weight-normal"  translate>lblUserConsent</strong>
                        </p>
                    </label> 
                </div>
          </div>


          <div class=" col-12 mr-auto" *ngIf="!TCLink">
            <div class="form-group mb-0 mt-2">
                <label class="cstcheckbox flmid fullspace w100 bold
                font16">
                    <input type="checkbox" name="UserPrivacyAccept" formControlName="UserPrivacyAccept"
                        id="UserPrivacyAccept" class="form-check-input" required />
                    <span></span>
                    <p class="m-0 p-0">
                    <strong class="required-field font-weight-normal"  translate>lblIAcceptTheT&C's</strong>&nbsp;<u><a href="javascript:void(0);" class="link" (click)="openTnCPopup();" translate>lblreadmore</a></u>
                    </p>
                </label> 
            </div>
          </div>


            <div class=" col-auto ml-auto">
              <button translate aria-label="Center Align" [disabled]="!contactFormDetails.valid" class="btn btn-primary fright confirmbtn"  type="submit">lblConfirmAndOrder</button>
            </div>
          </div>
          </form>
        </div>
      </div>
      <div #otpTimer hidden></div>
    </div>
  </div>
</div>
